export const API_VERSION = '0.0.5';
